import React from "react";
import { NavLink } from "react-router-dom";
import Logo from '../assets/sanjivni ayurveda logo.png'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* Brand */}
        <div className="footer__logo">
          <img src={Logo} alt="Logo image" width="80px" />
          <div className="logo-text">
            <div className="footer__logo-text">
              Sanjivani<em>Ayurveda</em>
            </div>
            <div className="footer__logo-slogun">
              <em> सर्वे सन्तु निरामयाः</em> सर्वे भवन्तु सुखिनः
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="footer__col">
          <h4>Explore</h4>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/products">Products</NavLink>
          <NavLink to="/about">About Us</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </div>

        <div className="footer__col">
          <h4>Support</h4>
          <a href="#">FAQ</a>
          <a href="#">Shipping Policy</a>
          <a href="#">Returns</a>
          <a href="#">Privacy Policy</a>
        </div>

        <div className="footer__col">
          <h4>Connect</h4>
          <a href="https://www.instagram.com/sanjivaniayurvedasurendranagar/">Instagram</a>
          <a href="#www.facebook.com">Facebook</a>
          <a href="https://wa.me/919023510912" target="_blank">WhatsApp</a>
          <a href="#gmail.com">Email Us</a>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Sanjivani Ayurveda. All rights reserved.</p>
        <p>Designed & Developed by Shak7</p>
      </div>
    </footer>
  );
}
